import { clsx } from "clsx";

export default function ExpandCollapseIcon({
  isExpanded,
}: {
  isExpanded: boolean;
}) {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="size-4"
    >
      <title>toggle expanded icon</title>
      <path d="M10.7222 15L10.7222 1.38889" stroke="#030712" />
      <rect
        x="14.5"
        y="14.5"
        width="13"
        height="13"
        rx="1.83333"
        transform="rotate(-180 14.5 14.5)"
        stroke="#030712"
        className={isExpanded ? "" : "fill-black-950"}
      />
      <path
        d="M7.22225 10.3335L4.88892 8.00016L7.22225 5.66683"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={clsx(
          isExpanded
            ? "stroke-black-950 rotate-0"
            : "-translate-x-1 -scale-x-100 scale-y-100 origin-center stroke-black-100",
          "transition-transform duration-150",
        )}
      />
      <path
        d="M12.667 14.5L11 14.5L11 1.5L12.667 1.5C13.6793 1.50018 14.4998 2.32074 14.5 3.33301L14.5 12.667C14.4998 13.6793 13.6793 14.4998 12.667 14.5Z"
        stroke="#030712"
        className={isExpanded ? "fill-black-950" : "fill-black-100"}
      />
    </svg>
  );
}
